import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";

import ReferralDialogNavigation from "features/Home/ReferralDialog/navigation";
import { NEW_USER_REFERRAL_CREDIT } from "utils/influencer";
import { trackEvent } from "utils/tracking";

const SpecialAnnouncementReferral = () => {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [navigationReferDialog, setNavigationReferDialog] = useState(false);
  const { currentOrg } = useContext(OrganizationUserContext);

  const isNewOrg = () => {
    if (!currentOrg?.createdAt) return false;
    const createdAt = new Date(currentOrg.createdAt * 1000); // Convert from seconds to milliseconds
    const now = new Date();
    const twoWeeksInMs = 14 * 24 * 60 * 60 * 1000;
    return now.getTime() - createdAt.getTime() <= twoWeeksInMs;
  };

  const handleStartReferring = () => {
    trackEvent("Referral Promo Button Clicked");
    setNavigationReferDialog(true);
  };
  return isNewOrg() ? (
    <Grid
      container
      alignItems="center"
      sx={{ borderRadius: 2, boxShadow: 3, p: 3, mb: 3, mt: -3 }}
      item
      xs={12}
    >
      <Grid item xs={12} md={7} lg={8} container alignItems="center">
        <Typography component="div">
          <Box sx={{ fontSize: 15 }}>
            📢 <strong>New User Promo:</strong> Get 4x Bento credits for any new
            referral during your first two weeks on Bento!
            <br />
          </Box>
          Give ${NEW_USER_REFERRAL_CREDIT} to a new user. Get $
          {NEW_USER_REFERRAL_CREDIT} when they subscribe - enough for a month of
          Pro.
        </Typography>
      </Grid>

      <Grid
        item
        xs
        md
        lg
        container
        justifyContent={isMobileScreen ? "flex-start" : "flex-end"}
        sx={{ pr: 2, mt: { xs: 2, md: 0 } }}
      >
        <Button
          sx={{ backgroundColor: "info.main" }}
          variant="contained"
          disableElevation
          onClick={handleStartReferring}
        >
          Start Referring
        </Button>
      </Grid>
      <ReferralDialogNavigation
        open={navigationReferDialog}
        close={() => setNavigationReferDialog(false)}
        source="Referral Promo Button Clicked"
      />
    </Grid>
  ) : (
    <></>
  );
};

export default SpecialAnnouncementReferral;
